<template>
  <div class="condition">
    <time-display
      v-if="condition.type === 'time'"
      ref="timeDisplay"
      :condition="condition"
    ></time-display>
    <select-display
      v-else-if="selectTypes.includes(condition.type)"
      ref="selectDisplay"
      :condition="condition"
      :control-options-map="controlOptionsMap"
    ></select-display>
    <text-display
      v-else-if="textTypes.includes(condition.type)"
      ref="textDisplay"
      :condition="condition"
      :charts="charts"
      :filter-list="filterList"
      @getVarValueMap="getVarValueMap"
    ></text-display>
    <num-display
      v-else-if="numTypes.includes(condition.type)"
      ref="numDisplay"
      :condition="condition"
    ></num-display>
  </div>
</template>

<script>
import { numTypes, selectTypes, textTypes } from "@/views/Backend/Admin/Statistics/static"
import TimeDisplay from "@/views/Backend/Admin/Statistics/queryDisplay/TimeDisplay"
import SelectDisplay from "@/views/Backend/Admin/Statistics/queryDisplay/SelectDisplay"
import TextDisplay from "@/views/Backend/Admin/Statistics/queryDisplay/TextDisplay"
import NumDisplay from "@/views/Backend/Admin/Statistics/queryDisplay/NumDisplay"
import { deepClone } from "@/utils/common"

export default {
  name: "condition",
  components: { NumDisplay, TextDisplay, SelectDisplay, TimeDisplay },
  props: {
    condition: Object,
    controlOptionsMap: Object,
    charts: Array,
    varValueMap: Object
  },
  data() {
    return {
      selectTypes,
      textTypes,
      numTypes,
      result: true,
      filterList: []
    }
  },
  watch: {
    varValueMap: {
      handler() {
        let filters = deepClone(this.condition.filters) || []
        this._.flatten(filters).forEach(t => {
          t.varItems = t.varItems.flatMap(varItem => {
            if (!varItem.var) return varItem
            return this.varValueMap[varItem.value]?.map(v => ({ var: false, value: v }))
          })
        })
        this.filterList = filters
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getVarValueMap() {
      this.$emit("getVarValueMap")
    },
    async getFilters(chart) {
      let filters = []
      if (this.condition.type === "time") {
        filters = filters.concat(this.$refs.timeDisplay.getTimeFilters(chart))
      } else if (this.selectTypes.includes(this.condition.type)) {
        filters = filters.concat(await this.$refs.selectDisplay.getOptionFilters(chart))
      } else if (this.textTypes.includes(this.condition.type)) {
        filters = filters.concat(this.$refs.textDisplay.getTextFilters(chart))
      } else if (this.numTypes.includes(this.condition.type)) {
        filters = filters.concat(this.$refs.numDisplay.getNumFilters(chart))
      }
      return filters
    },
    getVerifyResult() {
      let result = true
      if (this.condition.required) {
        if (this.condition.type === "time") {
          result = this.$refs.timeDisplay.getVerify()
        } else if (this.selectTypes.includes(this.condition.type)) {
          result = this.$refs.selectDisplay.getVerify()
        } else if (this.textTypes.includes(this.condition.type)) {
          result = this.$refs.textDisplay.getVerify()
        } else if (this.numTypes.includes(this.condition.type)) {
          result = this.$refs.numDisplay.getVerify()
        }
      }
      this.result = result
    },
    getValue() {
      return this.$refs.textDisplay.getValue()
    }
  }
}
</script>

<style lang="scss" scoped>
.condition {
  margin-right: 10px;
}
</style>
